/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalRegisterStatus = {
  type: 'Enum',
} as const;
